

export enum Font {
    ROBOTO_CONDENSED =  "'Roboto Condensed','Lato','Helvetica Neue',Helvetica,Arial,sans-serif",
    LATO = "'Lato','Helvetica Neue',Helvetica,Arial,sans-serif"
}